var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vv-progress-bar',{attrs:{"progression":_vm.questionProgression.currentQuestion,"total":_vm.questionProgression.numberOfQuestions}})}
var staticRenderFns = []

export { render, staticRenderFns }